import React from "react"
import Loadable from '@loadable/component'
// import ApexCharts from 'apexcharts';
import {Checkbox} from 'antd';
import 'antd/dist/antd.css';

class BarChart extends React.Component {

  componentDidMount() {
    setTimeout(() => {
      console.log('down')
      ApexCharts.exec("basic-bar", 'toggleSeries', "Orlando");
      ApexCharts.exec("basic-bar", 'toggleSeries', "Seattle");
    }, 3000);
  }

  toggle(e) {
    ApexCharts.exec("basic-bar", 'toggleSeries', e.target.value);
  }

  render() {
    return (
      <>
        <div style={{border: "4px dotted white"}}>
          <div style={{textAlign: 'center'}}>
            <div style={{display: "inline-block"}}>
              <h3>Histogram: # days with average T in past 5 years</h3>
            </div>
          </div>

          <div style={{textAlign: 'center'}}>
            <div style={{display: "inline-block"}}>
              <Checkbox defaultChecked={1} value="Long Beach" onChange={this.toggle}>Long Beach</Checkbox>
              <Checkbox defaultChecked={1} value="Washington DC" onChange={this.toggle}>Washington DC</Checkbox>
              <Checkbox defaultChecked={0} value="Orlando" onChange={this.toggle}>Orlando</Checkbox>
              <Checkbox defaultChecked={0} value="Seattle" onChange={this.toggle}>Seattle</Checkbox>
            </div>
          </div>

        </div>
        <LoadableChart
          options={{
            dataLabels: {enabled: false},
            legend: {position: 'bottom',},
            chart: {
              id: "basic-bar"
            },
            xaxis: {
              title: {
                text: 'Temperature intervals (in Fahrenheit)'
              },
              categories: [
                ' 13 - 21 ',
                ' 21 - 29 ',
                ' 29 - 36 ',
                ' 36 - 44 ',
                ' 44 - 52 ',
                ' 52 - 60 ',
                ' 60 - 68 ',
                ' 68 - 75 ',
                ' 75 - 83 ',
                ' 83 - 91 ',
              ]
            },
            yaxis: {
              title: {
                text: 'Number of days'
              },
            }
          }}
          series={[
            {
              name: "Long Beach",
              data: [0, 0, 0, 0, 33, 315, 662, 478, 124, 9]
            }, {
              name: "Washington DC",
              data: [18, 42, 99, 216, 202, 217, 190, 223, 333, 81]
            }, {
              name: "Orlando",
              data: [0, 0, 0, 5, 31, 114, 202, 471, 723, 75]
            }, {
              name: "Seattle",
              data: [0, 7, 55, 256, 422, 382, 325, 140, 34, 0]
            },

          ]}
          type="histogram"
          height="350"

        />
      </>)
  }
}

export default BarChart

// import react-apexcharts here
const LoadableChart = Loadable(() => import('../../node_modules/react-apexcharts/src/react-apexcharts'));
